// Shopify system headings follow the store locale; ELUNE's storefront is English.
(() => {
 const titles={'privacy-policy':'Privacy Policy','refund-policy':'Refund Policy','shipping-policy':'Shipping Policy','terms-of-service':'Terms of Service','contact-information':'Contact Information'};
 const key=location.pathname.split('/').filter(Boolean).pop();
 const heading=document.querySelector('.shopify-policy__title h1');
 if(heading&&titles[key]){heading.textContent=titles[key];document.title=titles[key]+' | ELUNE';}
})();
